import api from '@/api/app'
import { resolve } from 'core-js/fn/promise'
const statistics = {
  statistics: {
    viewInfo: {
      obj: {
        data1: [
          {
            title: '装备统计',
            url: require('@/assets/statistics/zbtj.png'),
            path: '/statistics/count',
            option: '点击进入'
          },
          {
            title: '装备申报',
            url: require('@/assets/statistics/zbsb.png'),
            path: '/statistics/declare',
            option: '点击进入'
          }
        ],
        tabs: [
          {
            id: 111,
            key: 0,
            name: '信息录入',
            type: 'text'
          },
          {
            id: 222,
            key: 1,
            name: '信息查询',
            type: 'text'
          },
          {
            id: 333,
            key: 2,
            name: '通知公告',
            type: 'text'
          }
        ],
        tabs1: [
          {
            id: 111,
            key: 0,
            name: '学校基本信息',
            type: 'text'
          },
          {
            id: 222,
            key: 1,
            name: '实验室情况',
            type: 'text'
          },
          {
            id: 333,
            key: 2,
            name: '图书馆情况',
            type: 'text'
          },
          {
            id: 444,
            key: 3,
            name: '音体美卫情况',
            type: 'text'
          },
          {
            id: 555,
            key: 4,
            name: '信息化设备情况',
            type: 'text'
          },
          {
            id: 666,
            key: 5,
            name: '课桌椅校服情况',
            type: 'text'
          },
          {
            id: 777,
            key: 6,
            name: '学生生活附属设施',
            type: 'text'
          }
        ],
        tabs2: [
          {
            id: 111,
            key: 0,
            name: '通知公告',
            type: 'text'
          }
        ],
        tabs3: [
          {
            id: 111,
            key: 0,
            name: '标准申报',
            type: 'text'
          },
          {
            id: 222,
            key: 1,
            name: '自主申报',
            type: 'text'
          },
          {
            id: 333,
            key: 2,
            name: '工作通知',
            type: 'text'
          }
        ],
        tabs4: [
          {
            id: 111,
            key: 0,
            name: '标准申报',
            type: 'text'
          }
        ],
        tabs5: [
          {
            id: 111,
            key: 0,
            name: '学校信息',
            type: 'text'
          },
          {
            id: 222,
            key: 1,
            name: '装备申报',
            type: 'text'
          }
        ],
        tabs6: [
          {
            id: 111,
            key: 0,
            name: '工作通知',
            type: 'text'
          },
          {
            id: 222,
            key: 1,
            name: '申报通知',
            type: 'text'
          }
        ],
        tableData: [
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111',
            cz1: '详情',
            cz2: '下载附件'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111',
            cz1: '详情',
            cz2: '下载附件'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111',
            cz1: '详情',
            cz2: '下载附件'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111',
            cz1: '详情',
            cz2: '下载附件'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111'
          },
          {
            dm: 1,
            zbmc: '1.1学校名称',
            dw: 'm²',
            sz: '登封市白坪乡初级中学',
            qzlj: '111111'
          }
        ],
        options: [
          {
            value: '选项1',
            label: '2019年装备统计'
          },
          {
            value: '选项2',
            label: '2020年装备统计'
          },
          {
            value: '选项3',
            label: '2021年装备统计'
          },
          {
            value: '选项4',
            label: '2022年装备统计'
          }

        ]
      }
    },
    control: {},
    init: {
      tableMode: () => {
        return new Promise((resolve) => {
          api.statistics.mode().then((res) => {
            resolve(res.data)
          })
        })
      },
      tableData: () => {
        return new Promise((resolve) => {
          api.statistics.data().then((res) => {
            resolve(res.data)
          })
        })
      }
    }
  }
}

export default statistics
